import React from "react";
import { getPlaceStarsRating, getShortDate, getStarsImages } from "./placeUtils";

function Comment(props) {
  return (
    <div className="comment">
      <p>
        <span className="user-avatar">
          <img src={process.env.PUBLIC_URL + "/icons/user.png"} alt="" />
        </span>
        {props.item.username === undefined || props.item.username === "" ? "użytkownik" : props.item.username}
      </p>
      <hr></hr>
      <div className="profile-stars-rating">
        <span>
          <p>{getStarsImages(getPlaceStarsRating(props.item))}</p>
        </span>
      </div>
      <p>{props.item.comment}</p>
      <div className="comment-date">
        <p>Dodano: {getShortDate(props.item.date)}</p>
      </div>
    </div>
  );
}

export default Comment;
